import {mapFilters} from "@/utils/helpers";

const initState = () => ({
  pendingGiftCard: null,
})

export const state = initState

export const getters = {
}

export const mutations = {
  setPendingGiftCard(state, {giftCard}){
    state.pendingGiftCard = giftCard
  },
  clearPendingGiftCard(state){
    state.pendingGiftCard = null
  },
}
export const actions = {
  async fetchVoucherTypes(){
    let voucherTypes = [];
    try{
      const result = await this.$axios.$get(`/webpos/voucher/voucher-types`)
      if (!result?.value || result.apiMessages?.hasErrors) {
        this.$toast.error('Error while getting voucher types')
      }
      else{
        voucherTypes = result.value;
      }
    }
    catch(e){
      this.$toast.error('Error while getting voucher types')
    }
    return voucherTypes
  },
  async fetchUsageTypes(){
    let usageTypes = [];
    try{
      const result = await this.$axios.$get(`/webpos/voucher/usage-types`)
      if (!result?.value || result.apiMessages?.hasErrors) {
        this.$toast.error('Error while getting usage types')
      }
      else{
        usageTypes = result.value;
      }
    }
    catch(e){
      this.$toast.error('Error while getting usage types')
    }
    return usageTypes
  },
  async fetchStatusTypes(){
    let statusTypes = [];
    try{
      const result = await this.$axios.$get(`/webpos/voucher/status-types`)
      if (!result?.value || result.apiMessages?.hasErrors) {
        this.$toast.error('Error while getting status types')
      }
      else{
        statusTypes = result.value
      }
    }
    catch(e){
      this.$toast.error('Error while getting status types')
    }
    return statusTypes
  },
  async fetchVouchers({commit, state}, {pagingInfo, filters}){
    const url = `/webpos/voucher/vouchers`;
    let vouchers = [];
    let filter = mapFilters(filters, pagingInfo.pageNo, pagingInfo.pageSize, pagingInfo.sortBy, pagingInfo.sortAsc);
    const result = await this.$axios.$get(
      url,
      {
        params: filter
      });

    if(result && !result.hasErrors){
      vouchers = result;
    }
    else{
      this.$toast.error('Error while getting vouchers')
    }
    return vouchers;
  },
  async fetchVoucherHistories({commit, state}, {pagingInfo, filters}){
    let voucherHistories = [];
    let filter = mapFilters(filters, pagingInfo.pageNo, pagingInfo.pageSize, pagingInfo.sortBy, pagingInfo.sortAsc);
    const result = await this.$axios.$get(
      `/webpos/voucher/histories`,
      {
        params: filter
      });

    if(result && !result.hasErrors){
      voucherHistories = result;
    }
    else{
      this.$toast.error('Error while getting voucher histories')
    }
    return voucherHistories;
  },
  async checkCodeExists({}, {code}) {
    try {
      const result = await this.$axios.$get(`/webpos/voucher/check-code`, {params: {code}})
      if(result?.apiMessages?.hasErrors){
        this.$toast.error('Error while checking voucher code')
        return true
      }
      return !!result?.value
    }
    catch(e){
      this.$toast.error('Error while checking voucher code')
      return true
    }
  },
  async fetchVoucherByID({}, {id}) {
    let voucher = null
    try{
      const result = await this.$axios.$get(`/webpos/voucher/${id}`)
      if (!result?.value || result.apiMessages?.hasErrors) {
        this.$toast.error('Error while getting voucher')
      }
      else{
        voucher = result.value
      }
    }
    catch(e){
      this.$toast.error('Error while getting voucher')
    }
    return voucher
  },
  async fetchVoucherByCode({}, {code}) {
    let voucher = null
    try {
      const result = await this.$axios.$get(`/webpos/voucher/get-by-code`, {params: {code}})

      if (!result?.value || result.apiMessages?.hasErrors) {
        this.$toast.error('Error while getting voucher by code')
      }
      else{
        voucher = result.value
      }
    }
    catch(e){
      this.$toast.error('Error while getting voucher')
    }
    return voucher
  },
  async deleteVoucher({}, {id}) {
    try {
      const result = await this.$axios.$delete(`/webpos/voucher/${id}`);
      if(result?.apiMessages?.hasErrors){
        this.$toast.error(result.apiMessages.serverErrors?.[0] || "Error while deleting voucher!");
        return false;
      }
      this.$toast.success("Voucher deleted successfully!");
      return true;
    } catch (e) {
      this.$toast.error("Error while deleting voucher!");
      return false;
    }
  },
  async save({}, {voucherDetail}) {
    try {
      const result = await this.$axios.$post(`webpos/voucher`, voucherDetail);
      if(result?.apiMessages?.hasErrors){
        this.$toast.error(result.apiMessages.serverErrors?.[0] || "Error while saving voucher");
        return false
      }
      else {
        this.$toast.success("Voucher save successfully");
        return true
      }
    }
    catch (ex) {
      this.$toast.error("Error while saving voucher")
    }
  },
  async isVoucherAlreadyUsed({}, {voucherID, customerID}){
    let voucherUsedByCustomer = false
    try {
      const result = await this.$axios.$get(`/webpos/voucher/is-voucher-already-used`, {params: {voucherID, customerID}})

      if (result.apiMessages?.hasErrors) {
        this.$toast.error('Error while validating voucher')
      }
      else{
        voucherUsedByCustomer = result.value
      }
    }
    catch(e){
      this.$toast.error('Error while validating voucher')
    }
    return voucherUsedByCustomer
  }
}
